
export class BenchmarkConfig {
	public static readonly riskBenchmarkPortfolios = [
		{
			id: 'SNP500',
			positions: [
				{
					identifier: 'SNP500',
					identifierType: 'ALADDIN_TICKER',
					weight: 100
				}
			]
		}
	];

	public static readonly betaPortfolios = [
		{
			id: 'SNP500',
			positions: [
				{
					identifier: 'SNP500',
					identifierType: 'ALADDIN_TICKER',
					weight: 100
				}
			]
		}
	];
}
